import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  lessonTests: [],
  lessonTest: null,
};

// getters
export const getters = {
  lessonTests: state => state.lessonTests,
};

// mutations
export const mutations = {
  [types.FETCH_LESSON_TESTS_SUCCESS] (state, { lessonTests }) {
    state.lessonTests = lessonTests
  },

  [types.FETCH_LESSON_TESTS_FAILURE] (state) {
    state.lessonTests = null
  },
};

// actions
export const actions = {

  async fetchLessonTests ({ commit }, { lessonId }) {
    try {
      const { data } = await axios.get('/api/lesson-tests/' + lessonId);

      commit(types.FETCH_LESSON_TESTS_SUCCESS, { lessonTests: data })
    } catch (e) {
      commit(types.FETCH_LESSON_TESTS_FAILURE)
    }
  },
  async fetchFullLessonTests ({ commit }, { lessonId }) {
    try {
      const { data } = await axios.get('/api/admin/lesson-tests/' + lessonId);

      commit(types.FETCH_LESSON_TESTS_SUCCESS, { lessonTests: data })
    } catch (e) {
      commit(types.FETCH_LESSON_TESTS_FAILURE)
    }
  },
};
